module.exports = __webpack_public_path__ + "static/media/decentralized.caa4bf20.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/decentralized.png
// module id = 209
// module chunks = 0